import PropTypes from 'prop-types';
import { useValidation } from '@eti/providers';
import { RadioGroup as EtiRadioGroup } from '@eti/components';
import { Field } from 'redux-form';
import { jsx as _jsx } from "react/jsx-runtime";
const isFalsy = val => val === null || typeof val === 'undefined' || typeof val === 'string' && !val;
const mapPropsToProps = _ref => {
  let {
    input,
    meta,
    ...props
  } = _ref;
  return {
    ...props,
    errorMessage: meta.touched ? meta.error : null,
    selectedValue: !isFalsy(input.value) ? input.value : null,
    onChange: input.onChange
  };
};
const RadioGroup = props => /*#__PURE__*/_jsx(EtiRadioGroup, {
  ...mapPropsToProps(props)
});
const RadioGroupField = _ref2 => {
  let {
    name,
    formatGet,
    formatSet,
    onChange,
    validationRuleName,
    ...props
  } = _ref2;
  const validate = useValidation(validationRuleName);
  return /*#__PURE__*/_jsx(Field, {
    component: RadioGroup,
    format: formatGet,
    name: name,
    normalize: formatSet,
    onChange: onChange,
    props: {
      ...props,
      name
    },
    validate: validate
  });
};
RadioGroupField.propTypes = {
  formatGet: PropTypes.func,
  formatSet: PropTypes.func,
  name: PropTypes.string,
  onChange: PropTypes.func,
  validationRuleName: PropTypes.string
};
export default RadioGroupField;
//# sourceMappingURL=RadioGroup.js.map